import { _size } from './size';

export function _difference<T>(allValues: T[], valuesToFilter: T[]): T[] {
    let filteredArray = allValues;
    if (_size(valuesToFilter) > 0 && _size(allValues) > 0) {
        filteredArray = allValues.filter((num) => !valuesToFilter.includes(num));
    }
    return filteredArray;
}
